import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseRepository } from '@common/data/base';
import { environment } from '@environment/environment';
import { ApiResources } from '@constants/api-resources';

@Injectable()
export class FaturamentoRepository extends BaseRepository {
  constructor(http: HttpClient) {
    super(http, environment.serverAuthUrl, ApiResources.FATURAMENTO);
  }

  imprimirFatura(id: number | string) {
    return this.customClient.get(`${this.basePath}/${id}/imprimir-fatura`, { responseType : 'blob' })
  }

  imprimirBoleto(id: number | string) {
    return this.customClient.get(`${this.basePath}/${id}/imprimir-boleto`, { responseType : 'blob' })
  }
}
